module.exports = __webpack_public_path__ + "static/media/event4.67fb974a.png";